// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  BASE_DOMAIN: 'http://localhost:4200/#/',
  API_URL: "https://sandbox-api.xcelapp.com/business-api",
  API_URL2: "https://sandbox-api.xcelapp.com",
  CUSTOMER_MANAGEMENT_URL: "https://sandbox-api.xcelapp.com/customer-managment",
  TRANSACTION_URL: "https://sandbox-api.xcelapp.com/transactions-service",
  ADMIN_BASE_URL: "https://sandbox-api.xcelapp.com/administrator",
  ESA_URL: "https://sandbox-api.xcelapp.com/esa",
  MERCHANT_AUTH_URL: "https://sandbox-api.xcelapp.com/merchant-auth",
  API_URL3: "https://sandbox-api.xcelapp.com/xas/v1",
  X_APP_ID: '640b794e6667f7cb1531a666',
  X_ISSUER_ID: '640b794d6667f7cb1531a65f',
  PUBLIC_KEY: 'eTz.test_e87f28c9934f7a01ee1b4d572414c7155f403fe3589806e3e346ff5d0b432326',
  PAYMENT_LINK: 'https://paygate.xcelapp.com/pay/',
  GHANA_CARD_API_URL: 'https://webpay.etranzactgh.com/GCV-PROD/verify',
  // GHANA_CARD_API_URL: 'http://54.154.96.54:8000/ghana-card-verifier/api/verify',
  GHANA_CARD_API_NAME: 'etranzactgh',
  GHANA_CARD_API_PASSWORD: '@tranzact78.9@',
  POSTHOG_KEY: 'phc_q9QhYcpxjQsp4CxhF2q5CbS3fgEohDTAVEXQWXYEjqWr',
  POSTHOG_HOST: 'https://us.i.posthog.com',
  GHANA_TERMS_URL: 'https://xcelghana.com/terms',
  DEFAULT_TERMS_URL: 'https://xcelapp.com/terms',
  GHANA_PRIVACY_URL: 'https://xcelghana.com/privacy-policy',
  DEFAULT_PRIVACY_URL: 'https://xcelapp.com/privacy-policy',
  GEOLOCATION_API_URL: 'https://ipapi.co/json/',




  // production: true,
  // BASE_DOMAIN: 'https://business.xcelapp.com/#/',
  // API_URL: "https://api.xcelapp.com/business-api",
  // API_URL2: "https://api.xcelapp.com",
  // CUSTOMER_MANAGEMENT_URL: "https://api.xcelapp.com/customer-managment",
  // TRANSACTION_URL: "https://api.xcelapp.com/transactions-service",
  // ADMIN_BASE_URL: "https://api.xcelapp.com/administrator",
  // ESA_URL: "https://api.xcelapp.com/esa",
  // MERCHANT_AUTH_URL: "https://api.xcelapp.com/merchant-auth",
  // API_URL3: "https://api.xcelapp.com/xas/v1",
  // X_APP_ID: '64c053730656499e578826c0',
  // X_ISSUER_ID: '64c051b60656499e578826bf',
  // PUBLIC_KEY: 'eTz.live_faf2ab8387b08df3d51d85c5e43f11e9d46f4a49cd9943b0f2fcd174bb7830d1',
  // PAYMENT_LINK: 'https://paygate.xcelapp.com/pay/',

  // production: true,
  // BASE_DOMAIN: 'https://business.xcelapp.com/#/',
  // API_URL : "https://api.xcelapp.com/business-api",
  // API_URL2 : "https://api.xcelapp.com",
  // CUSTOMER_MANAGEMENT_URL : "https://api.xcelapp.com/customer-managment",
  // TRANSACTION_URL:"https://api.xcelapp.com/transactions-service",
  // ADMIN_BASE_URL : "https://api.xcelapp.com/administrator",
  // ESA_URL : "https://api.xcelapp.com/esa",
  // MERCHANT_AUTH_URL: "https://api.xcelapp.com/merchant-auth",
  // API_URL3 : "https://api.xcelapp.com/xas/v1",
  // X_APP_ID: '64c053730656499e578826c0',
  // X_ISSUER_ID: '64c051b60656499e578826bf',
  // PUBLIC_KEY: 'eTz.live_faf2ab8387b08df3d51d85c5e43f11e9d46f4a49cd9943b0f2fcd174bb7830d1',
  // PAYMENT_LINK: 'https://paygate.xcelapp.com/pay/',













  // X_APP_ID: '640b794e6667f7cb1531a666',
  // X_ISSUER_ID: '640b794d6667f7cb1531a65f',
  // PUBLIC_KEY: 'eTz.test_e87f28c9934f7a01ee1b4d572414c7155f403fe3589806e3e346ff5d0b432326',

  // API_URL : "https://sandbox-api.xcelapp.com",

  // API_URL3 : "https://sandbox-api.xcelapp.com/xas/v1",

  // X_APP_ID: '640b794e6667f7cb1531a666',
  // X_ISSUER_ID: '640b794d6667f7cb1531a65f',
  // PUBLIC_KEY: 'eTz.test_e87f28c9934f7a01ee1b4d572414c7155f403fe3589806e3e346ff5d0b432326',


  // CUSTOMER_MANAGEMENT_URL : "https://sandbox-api.xcelapp.com/customer-managment",
  // ADMIN_BASE_URL : "https://sandbox-api.xcelapp.com/administrator",
  // ESA_URL : "https://sandbox-esa-rhcss.ondigitalocean.app",
  // MERCHANT_AUTH_URL: "https://sandbox-api.xcelapp.com/merchant-auth/merchant-auth",
  // SANDBOX_URL:"https://sandbox-api.xcelapp.com/business-api"
};